import { render, staticRenderFns } from "./ProductsCartAnalysis.vue?vue&type=template&id=517f704a&scoped=true&"
import script from "./ProductsCartAnalysis.vue?vue&type=script&lang=js&"
export * from "./ProductsCartAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./ProductsCartAnalysis.vue?vue&type=style&index=0&id=517f704a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517f704a",
  null
  
)

export default component.exports